import React, { useEffect } from "react";
import "./assets/css/main.css"
import { Route, Routes, useNavigate } from "react-router-dom";
import { privateRoutes, publicRoutes } from "./router";
import { setIsAuth, setUser } from "./store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { authAPI } from "./api/user/userAPI";
import { getCategoryAccessCategory } from "./helpers/user/UserHelper";
import { getUnitMeasuresAPI } from "./api/unitMeasure/unitMeasureAPI";
import { setUnitMeasures } from "./store/settingsSlice";

function App() {

	const isAuth = useSelector(state => state.user.isAuth)
	const user = useSelector(state => state.user.user)
	const dispatch = useDispatch()
	const navigate = useNavigate()

	useEffect(() => {
		if (localStorage.getItem('token') && !user.id) {
			authAPI().then(data => {
				localStorage.setItem('token', data.accessToken)
				dispatch(setUser(data.user))
				dispatch(setIsAuth(true))
			}).catch(e => {
				navigate('/login')
			})
		} else if (!localStorage.getItem('token')) {
			navigate('/login')
		}
	}, [])

	useEffect(() => { // Отримуємо налаштування базові
		if (isAuth) {
			getUnitMeasuresAPI().then(data => {
				dispatch(setUnitMeasures(data))
			}).catch(e => {
				console.error('Отримання од. виміру', e)
			})
		}
	}, [isAuth])

  return (
    <div className="App">
		<Routes>
			{privateRoutes.map(route => {
				const access = getCategoryAccessCategory ({ 
					path: route.path,
					permissions: user && user.permissions ? user.permissions : null
				})
				if (access || route.path === '403') {
					return <Route 
						path={route.path} 
						element={route.element} 
						key={route.path} 
					/>	
				}
			})}

			{publicRoutes.map(route => 
				<Route 
					path={route.path} 
					element={route.element} 
					key={route.path} 
				/>	
			)}
		</Routes>
    </div>
  );
}

export default App;
